import {
    mapDataToCategories,
    mapDataToCustomTags,
    Columns,
    updateTagsConfig,
} from "@/modules/shared/ui/ReactTableTags";
import type { AdditionalConfig, TagUpdateValue, TagsConfig } from "@/modules/shared/ui/ReactTableTags";
import TagsTables from "@/modules/shared/ui/TagsTables";
import type { ITags } from "@/lib/models";
import { LINE_GROUP_TAGS } from "@/lib/ManufacturingTagsEditor.generated";
import { LINE_GROUP_TAGS_ACCESS } from "@/lib/ManufacturingTags.generated";

import UserDocumentationLink from "@/modules/shared/UserDocumentationLink";

const additional_config: AdditionalConfig = {
    day_shift_assignment_format: {
        validate: () => false,
    },
    gantt_number_of_days: {
        validate: () => false,
    },
    gantt_past_weeks: {
        validate: () => false,
    },
    gantt_min_day_width: {
        validate: () => false,
    },
    microplan_weeks: {
        validate: () => false,
    },
    microplan_gantt_number_of_days: {
        validate: () => false,
    },
};

type Props = {
    tags: ITags;
    onChangeCell: (name: string) => (value: TagUpdateValue) => void;
};

const LineGroupEditTags = (props: Props) => {
    const tagsConfig = updateTagsConfig(LINE_GROUP_TAGS as TagsConfig, additional_config);
    const tagCategories = mapDataToCategories(props.tags, tagsConfig, LINE_GROUP_TAGS_ACCESS);

    return (
        <>
            <div className="text-right mb-3">
                <UserDocumentationLink link_key={"line_groups"} />
            </div>
            <TagsTables
                categories={tagCategories}
                columns={Columns}
                onChangeCell={props.onChangeCell}
                customTags={mapDataToCustomTags(props.tags, tagsConfig)}
            />
        </>
    );
};

export default LineGroupEditTags;
